module.exports = __webpack_public_path__ + "img/kehu_04.43be363f.png";